'use strict';

const classNames = {
	clickableContainer: 'clickable-container',
	ignore: 'ignore',
	link: 'link',
};

const init = ($context) => {
	$.findByBem(classNames.clickableContainer, $context).off('click.clickableContainer').on('click.clickableContainer', function (e) {

		const $target = $(e.target);

		if ($target.closestByBem(classNames.clickableContainer, classNames.ignore).length > 0) {
			return;
		}

		e.stopImmediatePropagation();

		// Check for link, also check parent too and allow default. Otherwise override with target container link
		if (!$target.is('a') && !$target.closest('a').length > 0) {
			// No link has been clicked, so find the primary link and click it
			const $targetLinks = $(this).findByBem(classNames.clickableContainer, classNames.link);
			if ($targetLinks.length > 0) {
				$targetLinks[0].click();
			} else {
				$(this).find('a')[0].click();
			}
		}
	});
};

export default {
	init
}